import { getCookie, setCookie } from './libs/cookie';
import request from 'api/request';
import { ApiMap, ApiMapV2 } from 'api/config';
import { locStorage } from './libs/locStorage';
import XJJSBridge from '../JsBridge';
import { formatFrom, formatProtocol, formatIdCard, newFormatIdCard, formatName, newFormatName, formatMoney, handleSpace, addSpaceSeparator, formatBankLimit, PrefixInteger, setUrlParams } from './format';
import { compareVersion, is58App, isGanjiApp, is58APPVersionGreaterThan, isHaojieApp, isOldHaojieApp, isHaojieAppV1, isHaojieVersionGreaterThan, isHaojieSDK, isApp, getClientType, isNewFaceSdkApp, isIos, isPhone, isShtml, isAndroid, osAndClientType, isAndroidAppOrSdk, isMI10, isWechat, isWeixin, is58APPNewVersion, isH5 } from './UA';
import { setTitle, getWebType, pageJump, backAnzuHome, iphoneBackRefresh, listenBack, resetGoBack, accreditBackHome, sideToucGoBackhHandler, sideTouchHandler } from './platformCompatible';
import { riskBuryPoint, riskBuryPointForAsyncSqk, riskBuryTimestampPoint, riskDataForActivityReport, initClickRiskBuryPoint, setClickRiskBuryPoint, reportError, riskBusinessPoint } from './dataReport';
import { generateValidateRule, isEmojiCharacter } from './validate';
import { CUSTOMER_IMG } from 'pages/constants';

/**
 * 检查是否可以进行主动还款
 * @param orderNo 订单编号
 * @param repayType 还款类型 1-按期还款，2-提前结清
 * @param termNo 还款期数 若为提前结清则传 '-1'
 * @param toast toast提示框
 * @rps 带loading 的 request 函数
 * @returns 1 ---> 可以还款 2 ---> 不可以还款 3 ---> 查询异常
 */
const checkPayStatus = async (orderNo: string | number, repayType: string | number, termNo: string | number, toast: any, dialog: any, rps?: any): Promise<{ code: number; msg?: string }> => {
    try {
        const rp = rps || request;
        const res = await rp.get(ApiMap.checkCanPay, { orderNo, repayType, termNo });
        const { code, data, msg = '系统异常' } = res;

        if (code !== 0) {
            !rps && toast({ message: msg });
            return { code: 3, msg };
        }

        const { isAllow, notAllowMsg } = data;

        // toast类型提示
        if (isAllow === 0) {
            toast({ message: notAllowMsg });
            return { code: 2, msg: notAllowMsg };
        }

        // dialog类型提示
        if (isAllow === 2) {
            dialog({
                body: notAllowMsg || '当前不允许还款，请稍后重试',
                textOK: '确定',
                type: 'Alert'
            });
            return { code: 2, msg: notAllowMsg };
        }

        return { code: 1 };
    } catch (e) {
        toast({
            message: '系统异常'
        });
        return { code: 3, msg: '系统异常' };
    }
};

/**
 * @deprecated 类型检测器
 *
 */
interface whatTypeProps {
    [propName: string]: any;
}
const whatType: whatTypeProps = {};
const types = ['Array', 'Boolean', 'Date', 'Number', 'Object', 'RegExp', 'String', 'Error', 'Function', 'Promise'];
for (let i = 0, len = types.length; i < len; ++i) {

    let c = types[i];

    whatType[`is${c}`] = (function (type) {

        return function (arg) {
            return Object.prototype.toString.call(arg) === `[object ${type}]`;
        };

    })(c);
}

/**
 * 判断是否是函数
 */
const isFunc = (arg): boolean => {
    return typeof arg === 'function';
};

function getStyle(element, attr) {
    if (element.currentStyle) {
        return element.currentStyle[attr];
    } else {
        return getComputedStyle(element, null)[attr];
    }
}

const getiPhoneXBottomHeight = () => {
    const dom = document.getElementById('iphonex-info');
    let iPhoneXBottomHeight = 0;
    if (dom && iPhoneXBottomHeight === 0 && isApp() && isGanjiApp()) {
        iPhoneXBottomHeight = + getStyle(dom, 'height').replace('px', '');
    }
    return iPhoneXBottomHeight;
};

// 解决 dialog 透传滑动问题
const fixedBody = () => {
    let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    let clientWidth = document.body.clientWidth || document.documentElement.clientWidth;
    let moveWidth = clientWidth / 2;
    document.body.style.cssText += 'position:fixed;top:-' + scrollTop + 'px;left:50%;margin-left:-' + moveWidth + 'px;width:100%;';
};

const looseBody = () => {
    let body = document.body;
    body.style.position = '';
    let top = body.style.top;
    document.body.scrollTop = document.documentElement.scrollTop = -window.parseInt(top);
    body.style.top = '';
    body.style.left = '';
    body.style.marginLeft = '';
};

const getAbtestForWmda = () => {
    try {
        const t = new Date().getTime() + Math.floor(Math.random() * 10);
        !getCookie('abValue') && setCookie('abValue', t, 3650);

        const _headers = {
            abHeaders: {
                abValue: getCookie('wmda_uuid') || getCookie('abValue') || t
            }
        };

        request.get(ApiMapV2.abtest, _headers).then((res) => {
            if (res && res.code === 0) {
                const abValue = (res.data && res.data.abValue) || [];
                const ab_test = {};
                const { isSupport, set } = locStorage;
                abValue.forEach((item) => {
                    ab_test[`ab_test${item.layerId}`] = item.value;
                });

                isSupport() && set('ab_test', JSON.stringify({ ...ab_test }));
            }
        }).catch((err) => {

        });
    } catch (e) {
        console.log(e);
    }
};

// 判断是否支持webp格式图片（ios14以下不支持webp格式）
function isSupportWebp(callback) {
    var img = new Image();
    img.onload = function () {
        var result = (img.width > 0) && (img.height > 0);
        callback(result);
    };
    img.onerror = function () {
        callback(false);
    };
    img.src = "data:image/webp;base64,UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==";
}

const fomatLoadUrl = (url) => {
    const _origin = window.location.origin;
    const _protocol = window.location.protocol;
    if (url.indexOf('//') === 0) {
        return `${_protocol}${url}`;
    } else if (url.indexOf('http:') !== 0 && url.indexOf('https:') !== 0) {
        return `${_origin}${url}`;
    }
    return url;
}

// 针对赶集app下人脸流程跳出后无法返回的问题做更改
const pageTransferForGanji = (url, title = '', replace = false, disableScreenshot = false) => {
    const _url = fomatLoadUrl(url);
    let rmHeader = false; // 选填，是否添加header信息，10.5.5版本添加，主要用于打开第三方广告页面时，不添加header，用于解决header过大导致及安全隐患问题
    // 增加功能判断：是否为外链，如果是外链，则rmHeader为true，如果不是，则rmHeader为false
    const WhiteListByDomain = ['58.com']; // 白名单域名
    const hasInWhite = WhiteListByDomain.find(element => _url.indexOf(element) >= 0);
    if (!hasInWhite) {
        rmHeader = true;
    }
    // 默认的webType值
    // 赶集app使用的也是58app的载体，赶集内部看到58的版本号是10.2.0
    let webType = 'wkWebview';
    try {
        XJJSBridge.invoke('pagetrans', {
            action: 'pagetrans',
            tradeline: 'core',
            content: {
                pagetype: 'common',
                isfinish: replace,
                url: _url,
                title: title || '',
                disableScreenshot, // 是否禁用截屏和录屏，false为不禁用(默认)
                webType,
                rmHeader,
            },
        });
    } catch (error) {
        console.log(error)
    }
}

/**
 * 右上角按钮
 * @param call 
 */
const setCustomerBtn = (call) => { 
    if (!call) { 
    XJJSBridge.invoke('extend_btn', {
                config: [{
                    key: '',
                    txt: '',
                    icon:'',
                }],
    }, call);
        return;
    }
    XJJSBridge.invoke('extend_btn', {
            config: [{
                key: 'customer',
                txt: '',
                icon: CUSTOMER_IMG,
            }],
            cmd: 'init',
            type: 'horizontal'
        }, call);
}

// 获取页面 隐藏激活 属性 和事件名 兼容各个浏览器
function getPageActiveNameAndEventName(): Array<string> {
    let hidden;
    let visibilityChange;
    if (typeof document.hidden !== 'undefined') {
        hidden = 'hidden';
        visibilityChange = 'visibilitychange';
    } else if (typeof document.mozHidden !== 'undefined') {
        hidden = 'mozHidden';
        visibilityChange = 'mozvisibilitychange';
    } else if (typeof document.msHidden !== 'undefined') {
        hidden = 'msHidden';
        visibilityChange = 'msvisibilitychange';
    } else if (typeof document.webkitHidden !== 'undefined') {
        hidden = 'webkitHidden';
        visibilityChange = 'webkitvisibilitychange';
    }
    return [hidden, visibilityChange];
}

export {
    reportError,
    whatType,
    isMI10,
    isIos,
    isAndroid,
    isH5,
    isWechat,
    isWeixin,
    is58App,
    isGanjiApp,
    isHaojieApp,
    isApp,
    isPhone,
    isShtml,
    isFunc,
    riskBuryPoint,
    riskBuryPointForAsyncSqk,
    riskBuryTimestampPoint,
    riskDataForActivityReport,
    initClickRiskBuryPoint,
    setClickRiskBuryPoint,
    riskBusinessPoint,
    isOldHaojieApp,
    getiPhoneXBottomHeight,
    fixedBody,
    looseBody,
    addSpaceSeparator,
    isEmojiCharacter,
    isHaojieSDK,
    PrefixInteger,
    osAndClientType,
    formatFrom,
    setUrlParams,
    formatProtocol,
    formatIdCard,
    getClientType,
    checkPayStatus,
    formatName,
    compareVersion,
    isHaojieAppV1,
    isAndroidAppOrSdk,
    getAbtestForWmda,
    isNewFaceSdkApp,
    newFormatIdCard,
    newFormatName,
    setTitle,
    handleSpace,
    isHaojieVersionGreaterThan,
    getWebType,
    formatMoney,
    is58APPVersionGreaterThan,
    generateValidateRule,
    backAnzuHome,
    iphoneBackRefresh,
    pageJump,
    formatBankLimit,
    isSupportWebp,
    is58APPNewVersion,
    listenBack,
    resetGoBack,
    pageTransferForGanji,
    fomatLoadUrl,
    accreditBackHome,
    sideToucGoBackhHandler,
    sideTouchHandler,
    setCustomerBtn,
    getPageActiveNameAndEventName,
};
